var _rect, _g, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5500_35769",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5500_35769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58975 16.25C3.16881 16.25 2.8125 16.1041 2.52084 15.8125C2.22917 15.5208 2.08334 15.1645 2.08334 14.7435V5.25642C2.08334 4.83547 2.22917 4.47917 2.52084 4.1875C2.8125 3.89583 3.16881 3.75 3.58975 3.75H16.4102C16.8312 3.75 17.1875 3.89583 17.4791 4.1875C17.7708 4.47917 17.9166 4.83547 17.9166 5.25642V14.7435C17.9166 15.1645 17.7708 15.5208 17.4791 15.8125C17.1875 16.1041 16.8312 16.25 16.4102 16.25H3.58975ZM9.99998 10.4647L3.33332 6.20187V14.7435C3.33332 14.8183 3.35736 14.8798 3.40544 14.9279C3.45352 14.9759 3.51496 15 3.58975 15H16.4102C16.485 15 16.5464 14.9759 16.5945 14.9279C16.6426 14.8798 16.6667 14.8183 16.6667 14.7435V6.20187L9.99998 10.4647ZM9.99998 9.16665L16.5384 4.99998H3.46152L9.99998 9.16665ZM3.33332 6.20187V4.99998V14.7435C3.33332 14.8183 3.35736 14.8798 3.40544 14.9279C3.45352 14.9759 3.51496 15 3.58975 15H3.33332V6.20187Z",
    fill: "#656E83"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14,
    r: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6813 13.2514L15.7368 15.1958C15.6749 15.2577 15.5945 15.2884 15.5137 15.2884C15.4324 15.2884 15.352 15.2577 15.2901 15.1958L14.3179 14.2236C14.1945 14.1002 14.1945 13.9002 14.3179 13.7768C14.4413 13.6535 14.6408 13.6535 14.7642 13.7768L15.5137 14.5259L17.2345 12.8046C17.3579 12.6813 17.5579 12.6813 17.6813 12.8046C17.8046 12.928 17.8046 13.128 17.6813 13.2514ZM16 10C13.7945 10 12 11.7945 12 14C12 16.2059 13.7945 18 16 18C18.2055 18 20 16.2059 20 14C20 11.7945 18.2055 10 16 10Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidEmail);
export default __webpack_public_path__ + "static/media/validEmail.389d9601d5a33f0b60004f53a19b94c2.svg";
export { ForwardRef as ReactComponent };